import { View, Pressable } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '@/theme';
import { Caption } from '@/components/ui/Text';

type TripRecapActionsProps = {
  onViewRecap?: () => void;
  onDownloadDossier: () => void;
  onShareRecap: () => void;
  onRebook: () => void;
  onFileExpense: () => void;
  onCreateStory?: () => void; // Callback to create trip story
  isDownloading?: boolean;
};

const ActionButton = ({
  icon,
  label,
  onPress,
  disabled = false,
  primary = false,
}: {
  icon: keyof typeof Ionicons.glyphMap;
  label: string;
  onPress: () => void;
  disabled?: boolean;
  primary?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      style={({ pressed }) => ({
        flex: 1,
        minWidth: 120,
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        paddingVertical: theme.spacing(1),
        paddingHorizontal: theme.spacing(0.75),
        justifyContent: 'center',
        borderRadius: theme.radii.md,
        borderWidth: 1,
        borderColor: primary ? theme.colors.primary : theme.colors.borderMuted,
        backgroundColor: primary ? theme.colors.primary : theme.colors.surface,
        opacity: disabled ? 0.5 : pressed ? 0.85 : 1,
      })}
      accessibilityRole="button"
      accessibilityLabel={label}
    >
      <Ionicons name={icon} size={16} color={primary ? theme.colors.background : theme.colors.text} />
      <Caption
        numberOfLines={1}
        ellipsizeMode="tail"
        style={{ fontSize: 12, fontWeight: '600', flexShrink: 1, color: primary ? theme.colors.background : theme.colors.text }}
      >
        {label}
      </Caption>
    </Pressable>
  );
};

export function TripRecapActions({
  onViewRecap,
  onDownloadDossier,
  onShareRecap,
  onRebook,
  onFileExpense,
  onCreateStory,
  isDownloading = false,
}: TripRecapActionsProps) {
  const theme = useTheme();
  return (
    <View
      style={{
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
      }}
    >
      <ActionButton
        icon={onViewRecap ? 'sparkles-outline' : 'share-social-outline'}
        label={onViewRecap ? 'View full recap' : 'Share recap'}
        onPress={onViewRecap ?? onShareRecap}
        primary
      />
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: theme.spacing(1) }}>
      {onCreateStory && (
        <ActionButton
          icon="sparkles"
          label="Create Story"
          onPress={onCreateStory}
        />
      )}
      <ActionButton
        icon={isDownloading ? 'cloud-download-outline' : 'document-text-outline'}
        label={isDownloading ? 'Preparing...' : 'Download dossier'}
        onPress={onDownloadDossier}
        disabled={isDownloading}
      />
      {onViewRecap && <ActionButton icon="share-social-outline" label="Share recap" onPress={onShareRecap} />}
      <ActionButton icon="sparkles-outline" label="Rebook similar" onPress={onRebook} />
      <ActionButton icon="card-outline" label="File expense" onPress={onFileExpense} />
      </View>
    </View>
  );
}






